import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import AccountPage from './pages/AccountPage';
import EnrollPage from './pages/EnrollPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ErrorPage from './pages/ErrorPage';
import BillPayPage from './pages/BillPayPage';
import LoanPage from './pages/LoanPage';
import PaymentPage from './pages/PaymentPage';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/enroll" element={<EnrollPage />} />
          <Route path="/forgotpassword" element={<ForgotPasswordPage />} />
          <Route path="/error" element={<ErrorPage />} />
          <Route path="/billpay" element={<BillPayPage />} />
          <Route path="/loan" element={<LoanPage />} />
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
